<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <rt-toast></rt-toast>
  <rt-loading></rt-loading>
  <rt-login-intro></rt-login-intro>
  <rt-whats-new></rt-whats-new>
</ion-app>
